import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import * as CopAct from '../../Actions/CopActions';
import { toEuros, toDate, estEnCoursDeChargement } from '../../App_Code/Utils';
import { mapStateToPropsWrapper, verificationProps } from '../CaptureErreurs';
import Chargement from '../Chargement';
import Card, { LigneCard } from '../Card';

function classeIcone(valide) {
    return valide ? 'text-success fas fa-check' : 'text-danger fas fa-times';
}

function classeSolde(solde) {
    return solde >= 0.0 ? 'text-success' : 'text-danger';
}

const CardBanque = ({ Banque, DateDebExeCourant }) => (
    <div className="col-md-12 col-lg-6">
        <Card Titre={Banque.Compte && Banque.Compte.Nom ? Banque.Compte.Nom : 'Banque'}>
            <div className="card-text mb-0">
                {Banque.Compte && <LigneCard titre="Code" valeur={`${Banque.Compte.Num} - ${Banque.Compte.Code}`} />}
                {Banque.Fournisseur && (
                    <LigneCard titre="Fournisseur" valeur={`${Banque.Fournisseur.Code} - ${Banque.Fournisseur.Nom}`} />
                )}
                {Banque.Rib && (
                    <LigneCard titre="IBAN" valeur={Banque.Rib.Iban} iconePost={classeIcone(Banque.Rib.Valide)} />
                )}
                {Banque.Rib && <LigneCard titre="BIC" valeur={Banque.Rib.Bic} />}
                {Banque.Compte && (
                    <LigneCard
                        titre={`Solde au ${toDate(new Date(), 'L')}`}
                        valeur={`${toEuros(Banque.Compte.Solde, true)} €`}
                        classeValeur={classeSolde(Banque.Compte.Solde)}
                        derniereLigne
                    />
                )}
            </div>
            <Link
                to={{
                    pathname: '/MaCopropriete/Banques/Historique',
                    state: { Banque, DateDebExeCourant },
                }}
                className="btn btn-outline-primary mt-3 mr-3"
            >
                Voir l&apos;historique bancaire
            </Link>
            {Banque.Compte &&
                (Banque.Compte.Code === 'BNQ') && (
                <Link
                    to={{
                        pathname: '/MaCopropriete/Banques/Releves',
                        state: { Banque },
                    }}
                    className="btn btn-outline-primary mt-3"
                >
                        Voir les relevés bancaires
                </Link>
            )}
        </Card>
    </div>
);

const PageBanques = ({
    EstMembreCS, Banques, DateDebExeCourant, location, history,
}) => {
    if (estEnCoursDeChargement(Banques)) return <Chargement />;
    if (Banques.length === 0) return null;
    if (!EstMembreCS) {
        const chemin = location.pathname.slice(1).split('/');
        history.push(chemin && chemin[0] ? `/${chemin[0]}` : '/');
        return null;
    }

    const lsBanques = Banques.map((banque, i) => (
        !banque.Compte.InactifOk ? <CardBanque key={i} Banque={banque} DateDebExeCourant={DateDebExeCourant} /> : null
    ));

    return <div className="row">{lsBanques}</div>;
};
PageBanques.displayName = 'PageBanques';
PageBanques.requiredProps = [
    'Banques', // Liste des fournisseurs
    'EstMembreCS', // Page accessible uniquement aux membres du CS
    'DateDebExeCourant', // Date de début de l'exercice courant
];

function mapStateToProps({
    AdhStore: { EstMembreCS },
    CopStore: {
        Cop: { DateDebExeCourant },
        Banques,
    },
}) {
    return {
        EstMembreCS,
        Banques,
        DateDebExeCourant,
    };
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(CopAct, dispatch) };
}

export default connect(mapStateToPropsWrapper(mapStateToProps), mapDispatchToProps)(verificationProps(PageBanques));



// WEBPACK FOOTER //
// ./src/components/MaCopro/PageBanques.js